export * from './router.reducer';



// WEBPACK FOOTER //
// C:/Users/user/projects/ansyn/src/app/packages/router/reducers/index.ts